var map = {
	"./TVdenwa.png": "6b14",
	"./gazoukensa.png": "6ee4",
	"./houmon.png": "642b",
	"./kentaikensa.png": "b941",
	"./komento.png": "2b40",
	"./seirikinoukensa.png": "bc7f",
	"./shochi.png": "efd2",
	"./touyaku.png": "8adf",
	"./tyuusha.png": "1098"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";